// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"519":"4ccb87f0","787":"21fce2d9"}[chunkId] + ".chunk.js";
};